export const changeMusic = (music) => {
    return {
        music,
        type: "CHANGE_MUSIC"
    }
}; 